/* MGC kar efekti - tum sayfalar, altta ince kar birikmesi, sol altta ac/kapat dugmesi (secim hatirlanir). 10 Ocak 2027'den sonra kendiliginden calismaz. Mobilde (750px alti) calismaz. */
(function () {
  var END = new Date('2027-01-10T00:00:00');
  if (new Date() > END) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  /* Mobilde kar efekti ve dugmesi kapali (sayfa hizi icin) */
  if (window.innerWidth < 750) return;

  var KEY = 'mgcSnowOff';
  function isOff() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setOff(v) { try { if (v) localStorage.setItem(KEY, '1'); else localStorage.removeItem(KEY); } catch (e) {} }

  var c = document.createElement('canvas');
  c.setAttribute('aria-hidden', 'true');
  c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
  document.body.appendChild(c);
  var ctx = c.getContext('2d');
  var W, H, dpr, flakes = [], running = false, enabled = !isOff(), last = 0;

  /* kar birikmesi: ekranin altinda 4px'lik sutunlar */
  var COL = 4, pile = [], pileMax = 22;

  /* ac/kapat dugmesi */
  if (!document.querySelector('link[href*="Montserrat:wght@700"]')) {
    var fl = document.createElement('link');
    fl.rel = 'stylesheet';
    fl.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap';
    document.head.appendChild(fl);
  }
  var st = document.createElement('style');
  st.textContent =
    '.mgc-snow-btn{position:fixed;left:16px;bottom:96px;z-index:2147483001;height:42px;padding:0 18px 0 12px;border-radius:999px;gap:9px;' +
    'border:0;background:#e27968;color:#122837;display:flex;align-items:center;' +
    'font-family:Montserrat,sans-serif;font-weight:700;font-size:12px;letter-spacing:.12em;line-height:1;text-transform:uppercase;white-space:nowrap;' +
    'cursor:pointer;box-shadow:0 4px 14px rgba(226,121,104,.4);transition:transform .2s,background .2s,color .2s;-webkit-tap-highlight-color:transparent}' +
    '.mgc-snow-btn:hover{transform:translateY(-2px)}' +
    '.mgc-snow-btn svg{width:20px;height:20px;display:block;flex:none}' +
    '.mgc-snow-btn .mgc-snow-x{opacity:0;transition:opacity .2s}' +
    '.mgc-snow-btn.is-off{background:#fff;color:#122837;box-shadow:0 0 0 1px #e27968,0 4px 14px rgba(18,40,55,.18)}' +
    '.mgc-snow-btn.is-off .mgc-snow-x{opacity:1}' +
    '@media (max-width:749px){.mgc-snow-btn{left:12px;bottom:84px;height:36px;padding:0 14px 0 10px;font-size:11px;gap:7px}.mgc-snow-btn svg{width:18px;height:18px}}';
  document.head.appendChild(st);

  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'mgc-snow-btn';
  b.innerHTML =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
    '<path d="M12 2v20M3.3 7l17.4 10M20.7 7L3.3 17M12 2l-2.2 2.2M12 2l2.2 2.2M12 22l-2.2-2.2M12 22l2.2-2.2' +
    'M3.3 7l.8 3M3.3 7l3-.8M20.7 17l-.8-3M20.7 17l-3 .8M20.7 7l-3-.8M20.7 7l-.8 3M3.3 17l3 .8M3.3 17l.8-3"/>' +
    '<path class="mgc-snow-x" d="M4 4l16 16" stroke-width="2.2"/></svg><span class="mgc-snow-t"></span>';
  document.body.appendChild(b);

  function label() {
    var t = enabled ? 'Stop snow' : 'Let it snow';
    b.querySelector('.mgc-snow-t').textContent = t;
    b.setAttribute('aria-pressed', enabled ? 'false' : 'true');
    b.classList.toggle('is-off', !enabled);
  }

  function count() { return W < 750 ? 40 : 85; }
  function make(top) {
    var r = Math.random();
    var size = r < 0.55 ? 3 + Math.random() * 2.5 : (r < 0.85 ? 5.5 + Math.random() * 3 : 9 + Math.random() * 6);
    return {
      x: Math.random() * W,
      y: top ? -10 - Math.random() * 40 : Math.random() * H,
      s: size,
      vy: 0.4 + size * 0.07 + Math.random() * 0.3,
      sway: 0.6 + Math.random() * 1.2,
      ph: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.01,
      rot: Math.random() * Math.PI,
      a: 0.7 + Math.random() * 0.3,
      crystal: size > 9
    };
  }
  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth; H = window.innerHeight;
    c.width = W * dpr; c.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    pileMax = W < 750 ? 14 : 22;
    var cols = Math.ceil(W / COL) + 2, old = pile;
    pile = [];
    for (var k = 0; k < cols; k++) pile.push(old.length ? (old[Math.min(k, old.length - 1)] || 0) : 0);
    var n = count();
    while (flakes.length < n) flakes.push(make(false));
    flakes.length = n;
  }
  function addSnow(x, s) {
    var i = Math.round(x / COL), amt = s * 0.6, spread = 4;
    for (var d = -spread; d <= spread; d++) {
      var j = i + d;
      if (j < 0 || j >= pile.length) continue;
      var w = 1 - Math.abs(d) / (spread + 1);
      pile[j] = Math.min(pileMax * (0.75 + 0.25 * Math.sin(j * 0.09) * Math.sin(j * 0.031 + 1)), pile[j] + amt * w);
    }
  }
  function groundAt(x) {
    var i = Math.round(x / COL);
    return H - (pile[i] || 0);
  }
  function drawPile() {
    if (!pile.length) return;
    ctx.beginPath();
    ctx.moveTo(0, H);
    for (var k = 0; k < pile.length; k++) ctx.lineTo(k * COL, H - pile[k]);
    ctx.lineTo(W, H);
    ctx.closePath();
    ctx.fillStyle = 'rgba(255,255,255,0.96)';
    ctx.fill();
    ctx.beginPath();
    for (var m = 0; m < pile.length; m++) {
      if (m === 0) ctx.moveTo(0, H - pile[0]); else ctx.lineTo(m * COL, H - pile[m]);
    }
    ctx.strokeStyle = 'rgba(18,40,55,0.18)';
    ctx.lineWidth = 1.5;
    ctx.stroke();
  }
  function drawCrystal(f) {
    ctx.save();
    ctx.translate(f.x, f.y); ctx.rotate(f.rot);
    ctx.lineCap = 'round';
    for (var pass = 0; pass < 2; pass++) {
      ctx.strokeStyle = pass ? 'rgba(255,255,255,' + f.a + ')' : 'rgba(18,40,55,' + (f.a * 0.25) + ')';
      ctx.lineWidth = pass ? 1.6 : 3.4;
      for (var i = 0; i < 6; i++) {
        ctx.rotate(Math.PI / 3);
        ctx.beginPath();
        ctx.moveTo(0, 0); ctx.lineTo(0, f.s);
        ctx.moveTo(0, f.s * 0.55); ctx.lineTo(f.s * 0.28, f.s * 0.78);
        ctx.moveTo(0, f.s * 0.55); ctx.lineTo(-f.s * 0.28, f.s * 0.78);
        ctx.stroke();
      }
    }
    ctx.restore();
  }
  function frame(t) {
    if (!running) return;
    var dt = last ? Math.min((t - last) / 16.7, 3) : 1; last = t;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];
      f.ph += 0.012 * dt;
      f.y += f.vy * dt;
      f.x += Math.sin(f.ph) * 0.35 * f.sway * dt;
      f.rot += f.spin * dt;
      if (f.x > W + 10) f.x = -10; else if (f.x < -10) f.x = W + 10;
      if (f.x >= 0 && f.x <= W && f.y >= groundAt(f.x)) { addSnow(f.x, f.s); flakes[i] = make(true); continue; }
      if (f.y > H + 10) { flakes[i] = make(true); continue; }
      if (f.crystal) { drawCrystal(f); continue; }
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.s * 0.5 + 0.8, 0, 6.2832);
      ctx.fillStyle = 'rgba(18,40,55,' + (f.a * 0.28) + ')';
      ctx.fill();
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.s * 0.5, 0, 6.2832);
      ctx.fillStyle = 'rgba(255,255,255,' + f.a + ')';
      ctx.fill();
    }
    for (var s = 1; s < pile.length - 1; s++) pile[s] = (pile[s - 1] + pile[s] * 2 + pile[s + 1]) / 4;
    drawPile();
    requestAnimationFrame(frame);
  }
  function start() {
    if (running || !enabled || document.hidden) return;
    c.style.display = '';
    running = true; last = 0;
    requestAnimationFrame(frame);
  }
  function stop() {
    running = false;
    ctx.clearRect(0, 0, W, H);
    c.style.display = 'none';
    for (var k = 0; k < pile.length; k++) pile[k] = 0;
  }
  b.addEventListener('click', function () {
    enabled = !enabled;
    setOff(!enabled);
    label();
    if (enabled) { flakes = []; resize(); start(); } else stop();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { running = false; } else { start(); }
  });
  window.addEventListener('resize', resize);
  resize();
  label();
  if (enabled) start(); else stop();
})();
